import React from "react";
import { useSelector } from "react-redux";
import { TextOverflow } from "utils/common";

import "./DeleteVersions.css";

export default function DeleteVersions({ versionIds = []}){
	let versions = useSelector((state) => {
		let { items } = state.creativeVersions;

		return versionIds
			.map((id) => {
				return items.find(version => version.id === id);
			})
			.filter(ver => ver);
	});

	let $rows = versions.map((version) => {
		let { id, name } = version || {};

		return (
			<tr key={id}>
				<td className="version-name-column"><TextOverflow value={name} /></td>
				<td className="version-id-column">{id}</td>
			</tr>
		);
	});

	return (
		<>
			<strong>Are you sure you want to delete the selected versions?</strong>
			<div className="scrollable-container">
				<table className="basic-table">
					<thead>
						<tr>
							<th>Version Name</th>
							<th>ID</th>
						</tr>
					</thead>
					<tbody>
						{$rows}
					</tbody>
				</table>
			</div>
		</>
	);
}

DeleteVersions.displayName = "DeleteVersionsModal";
